import { ShellUserAuthorityContextPermissions } from '../../core/models'
import { getShellApiInstance } from '../../common/shell-api-helpers'

/* istanbul ignore next */
export const isInvictus = () => {
  const hasPermission = getShellApiInstance().user.hasPermissions([
    ShellUserAuthorityContextPermissions.VIEW_SHARED_CONTACTS,
  ])

  return hasPermission
}
